<template>
    <email-capture
        v-slot="{ capture, hasBeenCaptured, isProcessing, errors }"
        :subscribeToNewsletter="true"
    >
        <form>
            <div class="text-center leading-tight mb-5">
                <slot></slot>
            </div>
            <input
                type="email"
                placeholder="Enter Your Email"
                v-model="email"
                class="rounded w-full text-center p-5"
                :disabled="isProcessing || hasBeenCaptured"
            />
            <div v-if="errors.has('email')" class="-mb-2 pl-8 pt-2 text-base">
                {{ errors.first('email') }}
            </div>
            <div v-if="errors.any() && !errors.has('email')" class="-mb-2 pl-8 pt-2 text-base">
                Whoops! An error has happened
            </div>
            <button
                type="submit"
                @click.prevent="capture(email)"
                class="px-8 py-5 mt-5 rounded text-white w-full font-display text-xl"
                :class="{
                    'bg-blue-darker cursor-default': isProcessing || hasBeenCaptured,
                    'bg-blue-lighter': !hasBeenCaptured && !isProcessing,
                }"
                :disabled="isProcessing || hasBeenCaptured"
            >
                {{ buttonText(isProcessing, hasBeenCaptured) }}
            </button>
            <email-captured-hook></email-captured-hook>
        </form>
    </email-capture>
</template>

<script>
export default {
    props: {
        variantColor: {
            required: true,
            type: String,
        },
    },

    computed: {
        buttonCss() {
            if (this.isProcessing) {
                return 'accent-color--darker cursor-default';
            }

            if (this.hasBeenCaptured) {
                return 'accent-color--darker cursor-default';
            }

            if (!this.hasBeenCaptured) {
                return 'accent-color';
            }
        },
    },

    data() {
        return {
            email: '',
        };
    },

    methods: {
        buttonText(isProcessing, hasBeenCaptured) {
            if (isProcessing) {
                return 'Subscribing...';
            }

            return hasBeenCaptured ? 'Subscribed ✓' : 'Subscribe';
        },
    },
};
</script>
